import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const testimonials = [{
  name: 'Sarah Jenkins',
  style: 'Knotless Braids',
  text: "Absolutely the best braiding experience I've ever had. The salon is beautiful, the staff is professional, and my edges are intact! The tension was perfect."
}, {
  name: 'Michelle O.',
  style: 'Goddess Locs',
  text: 'I felt like royalty from the moment I walked in. They really take their time to ensure every single loc is perfect. I get compliments daily.'
}, {
  name: 'Aisha T.',
  style: 'Stitch Braids',
  text: "Clean parts, neat braiding, and such a welcoming atmosphere. It's so hard to find a salon that values your time, but they started exactly at my appointment time."
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="py-24 bg-burgundy relative overflow-hidden" data-id="element-264">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full pattern-african opacity-10" data-id="element-265"></div>
      <div className="absolute -top-24 -right-24 w-64 h-64 border border-golden/20 rounded-full" data-id="element-266"></div>
      <div className="absolute -bottom-24 -left-24 w-80 h-80 border border-golden/20 rounded-full" data-id="element-267"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-268">
        <div className="text-center mb-16" data-id="element-269">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-heading font-bold text-cream mb-4" data-id="element-270">
            Client Love
          </motion.h2>
          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} className="h-1 w-24 bg-golden mx-auto rounded-full" data-id="element-271"></motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-272">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-jet/40 backdrop-blur-sm border border-golden/20 p-8 rounded-sm relative group hover:bg-jet/60 transition-colors duration-300" data-id="element-273">
              <QuoteIcon className="absolute top-6 right-6 w-12 h-12 text-golden/10 group-hover:text-golden/20 transition-colors" data-id="element-274" />

              <div className="flex gap-1 mb-6" data-id="element-275">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-golden text-golden" data-id="element-276" />)}
              </div>

              <p className="text-cream/90 text-lg leading-relaxed mb-8 font-light italic" data-id="element-277">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4 border-t border-golden/20 pt-4" data-id="element-278">
                <div className="w-12 h-12 bg-brown rounded-full flex items-center justify-center text-golden font-heading font-bold text-xl" data-id="element-279">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-280">
                  <h4 className="text-cream font-bold" data-id="element-281">{testimonial.name}</h4>
                  <p className="text-golden text-sm" data-id="element-282">{testimonial.style}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}